import React, { useEffect, useRef, useState } from 'react'
import { MenuItemType } from '@utils/types'
import styles from './NavMobile.module.sass'
import { Button, LangDropdown, WLink } from '@components/atoms'
import { NavPanel, NavPanelMobile } from '@components/molecules'
import useTrans from '@hooks/useTrans'
import { ArrowLeft, ArrowRight, ChevronRight, Close, Logo } from '@components/icons'
import { isOutsideClick } from '@utils/safe'
//import { trackingGAevent, uniformData } from '@utils/gtm'

interface Props {
  item?: MenuItemType
  bottomItem?: MenuItemType
  open?: boolean
  setOpen?: (v: boolean) => void
  langs?: MenuItemType[]
  className?: string
  openItem?: MenuItemType
  setOpenItem?: (v: MenuItemType) => void
}

const NavMobile = (props: Props) => {
  const {
    item = undefined,
    bottomItem = undefined,
    open = false,
    setOpen = undefined,
    langs = [],
    className = '',
    openItem = null,
    setOpenItem = () => {},
  } = props

  const t = useTrans()
  const ref = useRef(null)

  useEffect(() => {
    if (open) {
      const handleOutsideClick = (e) => {
        if (!!ref.current && !!setOpen) {
          if (!ref.current.contains(e.target)) {
            setOpen(false)
          }
        }
      }
      document.body.classList.add('w-noscroll')
      window.addEventListener('click', handleOutsideClick)
      return () => window?.removeEventListener('click', handleOutsideClick)
    } else document.body.classList.remove('w-noscroll')
  }, [open])

  const handleClickMenu = (label: string, position: string, type: string) => {
    // trackingGAevent('menu', {
    //   searchTerm: '',
    //   position: uniformData(position),
    //   label: uniformData(label),
    //   product: '',
    //   method: '',
    //   type: uniformData(type),
    // })
  }

  const handleClickHeader = (label: string) => {
    // trackingGAevent('header', {
    //   searchTerm: '',
    //   position: '',
    //   label: uniformData(label),
    //   product: '',
    //   method: '',
    //   type: '',
    // })
  }

  return (
    <div className={`${styles.root} ${open ? styles['root--open'] : ''} ${className}`} ref={ref}>
      <div className={styles.top}>
        {openItem ? (
          <button
            onClick={(e) => {
              e.stopPropagation()
              setOpenItem(null)
            }}
            className={styles.returnBtn}
          >
            <ArrowLeft />
            {openItem.name}
          </button>
        ) : (
          <WLink href={'/'} className={styles.logo}>
            <Logo />
          </WLink>
        )}
        <button
          type="button"
          aria-label={t('Chiudi menu')}
          onClick={() => setOpen(false)}
          className={styles.close}
        >
          <Close />
        </button>
      </div>
      <div
        className={`${styles.panel} ${styles['panel--main']} ${
          openItem ? '' : styles['panel--open']
        }`}
      >
        <nav className={styles.nav}>
          <ul role="menubar">
            {item?.children?.map((x) => (
              <li key={x.pk}>
                {x.children?.length ? (
                  <button
                    onClick={() => {
                      setOpenItem(openItem === x ? null : x)
                      handleClickMenu(x.name, 'first_level_menu', '')
                    }}
                    className={`${styles.item} ${styles['item--button']} ${
                      openItem === x ? styles['item--open'] : ''
                    }`}
                  >
                    <span className={styles.itemLabel}>{x.name}</span>
                    <ChevronRight />
                  </button>
                ) : (
                  <WLink
                    href={x.url}
                    newPage={x.blank}
                    className={`${styles.item} ${styles['item--link']}`}
                    onClick={() => handleClickMenu(x.name, 'first_level_menu', '')}
                  >
                    {x.name}
                  </WLink>
                )}
              </li>
            ))}
            {bottomItem?.children?.map((x, index) => (
              <li key={x.pk} className={index === 0 ? styles.bottomFirst : undefined}>
                <WLink
                  href={x.url}
                  newPage={x.blank}
                  className={`${styles.item} ${styles['item--bottom']} `}
                  onClick={() => handleClickMenu(x.name, 'first_level_menu', '')}
                >
                  {x.name}
                </WLink>
              </li>
            ))}
          </ul>
        </nav>
        {!!langs?.length && (
          <div className={styles.bottom}>
            <LangDropdown
              items={langs}
              variant="navmobile"
              position="burger_menu"
              onClick={() => handleClickHeader('language')}
              className={styles.langMobile}
            />
          </div>
        )}
      </div>
      {openItem && (
        <div
          key={openItem.pk}
          className={`${styles.panel} ${openItem ? styles['panel--open'] : ''}`}
        >
          <NavPanelMobile item={openItem} />
        </div>
      )}
    </div>
  )
}

export default NavMobile
